import { ReactComponent as CloseIcon } from 'assets/images/close-icon.svg';
import { Link, useLocation } from 'react-router-dom';
import routeCodes from 'common/constants/route-codes';
import { ReactComponent as NotificationIcon } from 'assets/images/notification.svg';
import { StyledIcon, StyledMessageButton } from '../../Messages/styled';

const SuperAdminMessages = () => {
  const { pathname } = useLocation();
  const isOpen = pathname === routeCodes.superAdmin.notifications;
  const hide = pathname.includes('tickets');

  return (
    <>
      {!hide && (
        <StyledMessageButton
          as={Link}
          to={isOpen ? routeCodes.home : routeCodes.superAdmin.notifications}
        >
          Area notifiche
          <StyledIcon as={isOpen ? CloseIcon : NotificationIcon} />
        </StyledMessageButton>
      )}
    </>
  );
};

export default SuperAdminMessages;
